function needHelp() {
    let helpBtn;
    let modal;
    let modalBackgound;
    let closeBtn;
    let topBar;
    let supportBtn;
    if (window.innerWidth > 820) {
        helpBtn = document.querySelector(".header .NEEDHELP");
        modal = document.querySelector(".top-bar .modal");
        modalBackgound = document.querySelector(".top-bar .modal-background");
        closeBtn = document.querySelector(".top-bar svg.closebtn");
    }
    else {
        helpBtn = document.querySelector(".mobile_nav-fixed--true .NEEDHELP");
        supportBtn = document.querySelector('.mobile-mega--bottom-bottom .support');
        modal = document.querySelector(".mobile_nav-fixed--true .modal");
        modalBackgound = document.querySelector(".mobile_nav-fixed--true .modal-background");
        closeBtn = document.querySelector(".mobile_nav-fixed--true svg.closebtn");
        topBar = document.querySelector(".mobile_nav-fixed--true .top-bar__menu-container");
    }

    const index = document.querySelector("body");

    helpBtn.addEventListener('click', function () {
        modal.style.display = "block";
        if (topBar) {
            topBar.style.display = "none";
        }
        index.style.overflowY = "hidden";
    });

    if (supportBtn) {
        supportBtn.addEventListener('click', function () {
            modal.style.display = "block";
            topBar.style.display = "none";
            index.style.overflowY = "hidden";
        });
    }

    modalBackgound.addEventListener('click', function () {
        modal.style.display = "none";
        if (topBar) {
            topBar.style.display = "block";
        }
        index.style.overflowY = "initial";
    });

    closeBtn.addEventListener('click', function () {
        modal.style.display = "none";
        if (topBar) {
            topBar.style.display = "block";
        }
        index.style.overflowY = "initial";
    });
}

setTimeout(() => {
    needHelp();
    document.addEventListener('shopify:section:load', needHelp);
}, 1000);
